import { Component, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";



@Component({
  selector: "app-update-notification",
  templateUrl: "./update-notification.page.html",
  styleUrls: ["./update-notification.page.scss"],
})
export class UpdateNotificationPage implements OnInit {
  constructor(public platform: Platform) {}

  ngOnInit() {}
  async update() {
    if(Capacitor.getPlatform() == 'android'){
      await Browser.open({ url: "https://play.google.com/store/apps/details?id=com.sgiv.pd&hl=es_VE&gl=US" });
    }
    if(Capacitor.getPlatform() == 'ios'){
      await Browser.open({ url: "https://apps.apple.com/ve/app/pd-sgiv/id1441746491" });
    }
  }
}
